"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isModalVisibleByName = exports.getVisibleModalsNames = exports.getModalDataByName = exports.getLastModalName = void 0;
var getModals = function getModals(state) {
  return state.modals;
};
var getData = function getData(state) {
  return state.data;
};
var getModalState = function getModalState(state, modalName) {
  var modal = state.modals.find(function (elem) {
    return elem.name === modalName;
  });
  return modal || null;
};
var getModalDataByName = exports.getModalDataByName = function getModalDataByName(state, modalName) {
  var modalState = getModalState(state, modalName);
  return modalState ? getData(modalState) : null;
};
var isModalVisibleByName = exports.isModalVisibleByName = function isModalVisibleByName(state, modalName) {
  var modals = getModals(state);
  return modals.some(function (elem) {
    return elem.name === modalName;
  });
};
var getVisibleModalsNames = exports.getVisibleModalsNames = function getVisibleModalsNames(state) {
  var modals = getModals(state);
  return modals.map(function (modal) {
    return modal.name;
  });
};
var getLastModalName = exports.getLastModalName = function getLastModalName(state) {
  var modals = getModals(state);
  return modals.length > 0 ? modals[modals.length - 1].name : null;
};